import { Data } from "../../../../../features/ui"
import { Currency } from "../../../../../tables/types/types"
import { useCashFundActions } from "../../../actions/cashFundActions"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { useCashFundLoaders } from "../../../loaders/cashFundLoaders"
import { useCashFundBuilders } from "../../../builders/cashFundBuilders"
import { Data2 } from "../../../../../features/data-types"

export const useActions = () => {
    const { buildCashFund } = useCashFundBuilders()

    const cashFundLoaders = useCashFundLoaders()

    const { saveCashFund } = useCashFundActions()

    const submitCashFund = async (
        data: Data,
        createMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)
        
        const { name, type } = data
        const id = data.id! as string
        const { findCashFund } = cashFundLoaders()
        const loadedCashFund = findCashFund(id)
        const cashFundData: Data2 = loadedCashFund ? {
            ...loadedCashFund,
            name,
            type
        } : {
            id,
            name,
            type,
            availableAmount: 0,
            reservedAmount: 0,
            currency: Currency.ARS
        }
        const cashFund = buildCashFund(cashFundData)
        
        await saveCashFund(cashFund)
        Emitter.emit(Event.DB_SUBMIT_DONE, createMode)
    }
    
    return {
        submitCashFund
    }
}
